<div
  class="file-card"
  [class.file-card--error]="card.rejectionReason"
  [class.file-card--checking]="card.isChecking">
  <div class="file-card__select">
    <app-checkbox
      [ngModel]="card.selected"
      (ngModelChange)="onSelectedChange($event)"
      [disabled]="!canBeSelected"></app-checkbox>
  </div>

  <div class="file-card__preview">
    <img
      *ngIf="!isTiffPreview"
      [src]="card.previewUrl"
      alt="preview" />
    <div
      *ngIf="isTiffPreview"
      class="file-card__preview-placeholder">
      <i class="pi pi-map"></i>
    </div>
    <div
      class="file-card__status"
      *ngIf="card.isChecking">
      <app-loading
        [loading]="true"
        width="24px"
        height="24px"></app-loading>
    </div>
  </div>

  <div class="file-card__content">
    <div class="file-card__title-section">
      <app-input
        [(ngModel)]="card.title"
        (ngModelChange)="onTitleChange($event)"
        [placeholder]="'UPLOADED_GEO_IMAGES.MODAL_TITLE_PLACEHOLDER' | translate"
        class="file-card__title-input"></app-input>
      <span
        class="file-card__status-badge"
        [class.file-card__status-badge--ok]="canBeSelected"
        [class.file-card__status-badge--warn]="needsManualCoordinates"
        [class.file-card__status-badge--error]="card.rejectionReason">
        {{ statusLabelKey | translate }}
      </span>
      <app-secondary-button
        *ngIf="showApplyAll"
        size="small"
        class="file-card__apply-all-btn"
        [title]="'UPLOADED_GEO_IMAGES.MODAL_APPLY_TO_ALL' | translate"
        (action)="applyAll.emit()"></app-secondary-button>
    </div>

    <div class="file-card__meta-item">
      <span class="meta-label">{{ formattedFileSize }} {{ 'UPLOADED_GEO_IMAGES.UNIT_MB' | translate }}</span>
    </div>

    <div
      class="file-card__meta-item"
      *ngIf="card.imageKind !== 'Raster'">
      <span class="meta-label">{{ "UPLOADED_GEO_IMAGES.MODAL_COORDINATES" | translate }}:</span>
      <span class="meta-value">{{ formattedCoordinates || "—" }}</span>
      <app-secondary-button
        *ngIf="needsManualCoordinates"
        size="small"
        [title]="'UPLOADED_GEO_IMAGES.MODAL_ENTER_COORDINATES' | translate"
        (action)="enterCoordinates.emit()"></app-secondary-button>
    </div>
    <div
      class="file-card__meta-item"
      *ngIf="card.imageKind === 'Raster'">
      <span class="meta-label">{{ "UPLOADED_GEO_IMAGES.MODAL_FOOTPRINT" | translate }}:</span>
      <span class="meta-value">{{ card.footprintWkt ? "✓" : "—" }}</span>
    </div>

    <div class="file-card__meta-item">
      <span class="meta-label">{{ "UPLOADED_GEO_IMAGES.MODAL_CAPTURE_DATE" | translate }}:</span>
      <span class="meta-value">
        {{ formattedDate || ("UPLOADED_GEO_IMAGES.MODAL_DATE_NOT_AVAILABLE" | translate) }}
      </span>
    </div>

    <div class="file-card__tags-section">
      <app-tag-selector
        [selectedTagIds]="card.tagIds"
        [label]="'UPLOADED_GEO_IMAGES.MODAL_TAGS'"
        [placeholder]="'UPLOADED_GEO_IMAGES.MODAL_TAGS_PLACEHOLDER'"
        [allowCreate]="true"
        (selectedTagIdsChange)="onTagIdsChange($event)"></app-tag-selector>
    </div>
  </div>

  <button
    class="file-card__remove"
    (click)="handleRemove($event)"
    type="button"
    [title]="'UPLOADED_GEO_IMAGES.MODAL_REMOVE_FILE' | translate">
    <i class="pi pi-times"></i>
  </button>
</div>
